export const enum FundAvailability {
    BOTH = 'both',
    HSMAIN = 'hsmain',
    HI = 'hi'
}

export class Fund {
    portfolioFundCode?: string;
    portfolioLegalName?: string;
    portfolioClientCode?: string;
    investorFundCode?: string;
    investorLegalName?: string;
    availability?: string;
    fundNamesSource: string;

    constructor(init: Partial<Fund>, fundNamesSource: string) {
        this.portfolioFundCode = init.portfolioFundCode;
        this.portfolioLegalName = init.portfolioLegalName;
        this.portfolioClientCode = init.portfolioClientCode;
        this.investorFundCode = init.investorFundCode;
        this.investorLegalName = init.investorLegalName;
        this.availability = init.availability;

        this.fundNamesSource = fundNamesSource;
    }

    get fundId(): string {
        if (this.availability === FundAvailability.HSMAIN ||
            (this.availability === FundAvailability.BOTH && this.fundNamesSource === FundAvailability.HSMAIN.toString())) {
            return this.portfolioFundCode ?? 'PORTFOLIO FUND CODE WAS UNDEFINED AND SHOULD NOT HAVE BEEN';
        } else {
            return this.investorFundCode ?? 'INVESTOR FUND CODE WAS UNDEFINED AND SHOULD NOT HAVE BEEN';
        }
    }

    get fundName(): string {
        if (this.availability === FundAvailability.HSMAIN ||
            (this.availability === FundAvailability.BOTH && this.fundNamesSource === FundAvailability.HSMAIN.toString())) {
            return this.portfolioLegalName ?? 'PORTFOLIO LEGAL NAME WAS UNDEFINED AND SHOULD NOT HAVE BEEN';
        } else {
            return this.investorLegalName ?? 'INVESTOR LEGAL NAME WAS UNDEFINED AND SHOULD NOT HAVE BEEN';
        }
    }

    isHiOrBoth(): boolean {
        return this.availability === FundAvailability.HI || this.availability === FundAvailability.BOTH;
    }

    isHsMainOrBoth(): boolean {
        return this.availability === FundAvailability.HSMAIN || this.availability === FundAvailability.BOTH;
    }

    sameAs(other: Fund): boolean {
        return (this.fundId === other.fundId) ||
            (this.availability === FundAvailability.BOTH &&
            other.availability === FundAvailability.BOTH &&
            (this.portfolioFundCode === other.portfolioFundCode || this.investorFundCode === other.investorFundCode));
    }

    isIncludedInArrayOfIds(fundIds: string[]): boolean {
        return fundIds.includes(this.fundId) ||
            (
                this.availability === FundAvailability.BOTH &&
                (
                    (!!this.portfolioFundCode && fundIds.includes(this.portfolioFundCode)) ||
                    (!!this.investorFundCode && fundIds.includes(this.investorFundCode))
                )
            );
    }
}
